import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { useFormDataStore } from '@/stores/FormDataStore'
import { useHelpers } from '@/useHelpers'

export const useAddressStore = defineStore('AddressStore', () => {
  const formDataStore = useFormDataStore()
  const { isObjectEmpty } = useHelpers()

  const addressDraft = ref({})
  const invoiceAddressDraft = ref({})
  const packetaPickupPoint = ref()
  const selectedDeliveryMethod = ref('posta')

  const packetaDelivery = computed(() => selectedDeliveryMethod.value === 'zasilkovna')

  const selectPacketaPickupPoint = (point) => {
    packetaPickupPoint.value = point || packetaPickupPoint.value
  }

  const address = computed(() => {
    const addr = formDataStore.formData.address
    return isObjectEmpty(addr) ? addressDraft.value : addr
  })

  const invoiceAddress = computed(() => {
    const invoiceAddr = formDataStore.formData.invoiceAddress
    return isObjectEmpty(invoiceAddr) ? invoiceAddressDraft.value : invoiceAddr
  })

  const hasAddress = computed(() => !isObjectEmpty(address.value))

  const hasInvoiceAddress = computed(() => {
    return !isObjectEmpty(invoiceAddress.value) && invoiceAddress.value
  })

  const email = computed(() => window.init.email)

  const addressShort = computed(() => {
    if (hasAddress.value) {
      return `${address.value.first_name} ${address.value.last_name},
              ${address.value.address} ${address.value.number},
              ${address.value.city}`
    }
    return ''
  })

  const invoiceAddressShort = computed(() => {
    if (hasInvoiceAddress.value) {
      return `${invoiceAddress.value.company_name},
              ${invoiceAddress.value.address} ${invoiceAddress.value.number},
              ${invoiceAddress.value.city}`
    }
    return ''
  })

  const isICOValid = (x) => {
    try {
      let a = 0
      if (x.length === 0) {
        return false
      }
      if (x.length !== 8) {
        return false
      }
      let b = x.split('')
      let c = 0
      for (let i = 0; i < 7; i++) a += parseInt(b[i]) * (8 - i)
      a = a % 11
      c = 11 - a
      if (a === 1) c = 0
      if (a === 0) c = 1
      if (a === 10) c = 1
      if (parseInt(b[7]) !== c) {
        return false
      }
    } catch (e) {
      return false
    }
    return true
  }

  const isValidCZVAT = (id) => /^(CZ)(\d{8,10})(\d{3})?$/.test(id)

  const isValidSKVAT = (id) => /^(SK)([1-9]\d[(2-4)|(6-9)]\d{7})$/.test(id)

  return {
    address,
    addressShort,
    invoiceAddressShort,
    invoiceAddress,
    hasAddress,
    hasInvoiceAddress,
    isICOValid,
    email,
    isValidCZVAT,
    isValidSKVAT,
    addressDraft,
    invoiceAddressDraft,
    selectedDeliveryMethod,
    packetaDelivery,
    packetaPickupPoint,
    selectPacketaPickupPoint,
  }
}, {
  persist: [
    {
      paths: [
        'addressDraft',
        'invoiceAddressDraft',
      ],
    },
  ],
})
